import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/51_card_back_retro_car/51_card_back_retro_car"
 * Contains 1 texture(s)
 */
export class CardsBacks51CardBackRetroCarAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/51_card_back_retro_car/51_card_back_retro_car';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '51_retro_car.png'
    ] as const;
}
